import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/meeting-window.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/app/providers/app-providers.tsx");
